import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const ServerHardwareControllerNew = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            d="M11.8756 17.5365V17.042C11.8756 16.9729 11.9316 16.917 12.0006 16.917H15.4844C15.5534 16.917 15.6094 16.9729 15.6094 17.042V17.4461C15.6094 17.4802 15.5951 17.5134 15.57 17.5364C14.3623 18.6431 12.6851 18.0904 11.934 17.6413C11.8972 17.6193 11.8756 17.5794 11.8756 17.5365Z"
            fill="url(#paint0_linear_375_1366)"
          />
          <path
            d="M3.75 17.5367V17.0421C3.75 16.9731 3.80596 16.9171 3.875 16.9171H7.3588C7.42783 16.9171 7.4838 16.9731 7.4838 17.0421V17.4462C7.4838 17.4804 7.46953 17.5135 7.44435 17.5366C6.2367 18.6433 4.55953 18.0906 3.80838 17.6415C3.77157 17.6195 3.75 17.5796 3.75 17.5367Z"
            fill="url(#paint1_linear_375_1366)"
          />
          <path
            d="M18.0845 2.92301L18.7476 3.91611C18.7491 3.91849 18.75 3.9213 18.75 3.92417L18.7167 15.8618C18.7167 15.8647 18.7159 15.8675 18.7143 15.8698L18.0513 16.8629C17.8649 17.1444 17.4412 17.2245 17.2527 17.2294L2.3741 17.1415C2.08129 17.1297 2.00809 17.0095 2.00809 16.9509L1.87503 2.76497C1.87501 2.76286 1.87546 2.76075 1.87636 2.75885C1.94451 2.61506 2.16411 2.60539 2.27428 2.60053L17.2527 2.5419C17.7318 2.55363 18.0069 2.80086 18.0845 2.92301Z"
            fill="url(#paint2_linear_375_1366)"
          />
          <rect
            x="4.36829"
            y="5.36661"
            width="2.33362"
            height="1.66687"
            transform="rotate(90 4.36829 5.36661)"
            fill="url(#paint3_linear_375_1366)"
          />
          <rect
            x="18.2031"
            y="4.03322"
            width="0.466725"
            height="0.2667"
            rx="0.13335"
            transform="rotate(90 18.2031 4.03322)"
            fill="#709743"
          />
          <rect
            x="18.2031"
            y="8.56712"
            width="0.466725"
            height="0.2667"
            rx="0.13335"
            transform="rotate(90 18.2031 8.56712)"
            fill="#1D2628"
          />
          <rect
            x="18.2031"
            y="13.101"
            width="0.466725"
            height="0.2667"
            rx="0.13335"
            transform="rotate(90 18.2031 13.101)"
            fill="#709743"
          />
          <rect
            x="4.40121"
            y="2.5"
            width="3.7338"
            height="1.66687"
            transform="rotate(90 4.40121 2.5)"
            fill="#23728C"
          />
          <rect
            x="17.5366"
            y="2.5"
            width="3.7338"
            height="11.6014"
            transform="rotate(90 17.5366 2.5)"
            fill="#24728C"
          />
          <rect
            x="17.6031"
            y="3.10007"
            width="2.33362"
            height="11.6324"
            transform="rotate(90 17.6031 3.10007)"
            fill="url(#paint4_linear_375_1366)"
          />
          <rect
            x="17.5"
            y="6.25"
            width="1.25"
            height="11.5625"
            transform="rotate(90 17.5 6.25)"
            fill="#195167"
          />
          <rect
            x="5.9375"
            y="2.5"
            width="5"
            height="1.25"
            transform="rotate(90 5.9375 2.5)"
            fill="url(#paint5_linear_375_1366)"
          />
          <rect
            x="4.73508"
            y="2.5"
            width="3.7338"
            height="0.333375"
            transform="rotate(90 4.73508 2.5)"
            fill="#195167"
          />
          <path
            opacity="0.2"
            d="M8.4021 4.13858C8.4021 4.50403 8.11532 4.7989 7.76324 4.7989C7.41116 4.7989 7.12439 4.50403 7.12439 4.13858C7.12439 3.77313 7.41116 3.47825 7.76324 3.47825C8.11532 3.47825 8.4021 3.77313 8.4021 4.13858Z"
            fill="#233838"
            stroke="black"
            stroke-width="0.0503465"
          />
          <ellipse
            cx="7.7624"
            cy="4.13882"
            rx="0.46482"
            ry="0.479849"
            fill="#29637B"
          />
          <path
            d="M8.08253 4.13859C8.08253 4.32131 7.93915 4.46875 7.76311 4.46875C7.58707 4.46875 7.44368 4.32131 7.44368 4.13859C7.44368 3.95586 7.58707 3.80842 7.76311 3.80842C7.93915 3.80842 8.08253 3.95586 8.08253 4.13859Z"
            fill="url(#paint6_linear_375_1366)"
            stroke="#1B556F"
            stroke-width="0.0251733"
          />
          <rect
            x="4.42209"
            y="7.61768"
            width="3.93382"
            height="1.72077"
            transform="rotate(90 4.42209 7.61768)"
            fill="#23728C"
          />
          <rect
            x="17.5"
            y="7.1875"
            width="4.375"
            height="11.5625"
            transform="rotate(90 17.5 7.1875)"
            fill="#195167"
          />
          <rect
            x="17.6032"
            y="7.79285"
            width="2.95862"
            height="11.6324"
            transform="rotate(90 17.6032 7.79285)"
            fill="url(#paint7_linear_375_1366)"
          />
          <rect
            x="17.6032"
            y="11.5515"
            width="0.600075"
            height="11.6324"
            transform="rotate(90 17.6032 11.5515)"
            fill="#195167"
          />
          <rect
            x="5.93637"
            y="7.61768"
            width="3.93382"
            height="1.17012"
            transform="rotate(90 5.93637 7.61768)"
            fill="url(#paint8_linear_375_1366)"
          />
          <rect
            x="4.76624"
            y="7.61768"
            width="3.93382"
            height="0.344154"
            transform="rotate(90 4.76624 7.61768)"
            fill="#195167"
          />
          <rect
            x="4.42209"
            y="12.4695"
            width="3.93382"
            height="1.72077"
            transform="rotate(90 4.42209 12.4695)"
            fill="url(#paint9_linear_375_1366)"
          />
          <rect
            x="17.5"
            y="12.5"
            width="3.4375"
            height="11.5625"
            transform="rotate(90 17.5 12.5)"
            fill="#195167"
          />
          <rect
            x="17.6032"
            y="12.7928"
            width="2.95862"
            height="11.6324"
            transform="rotate(90 17.6032 12.7928)"
            fill="#283236"
          />
          <g filter="url(#filter0_i_375_1366)">
            <rect
              x="5.93637"
              y="12.4695"
              width="3.93382"
              height="1.17012"
              transform="rotate(90 5.93637 12.4695)"
              fill="#2F7FA3"
            />
          </g>
          <rect
            x="4.40125"
            y="12.1875"
            width="3.7338"
            height="1.66687"
            transform="rotate(90 4.40125 12.1875)"
            fill="#23728C"
          />
          <rect
            x="17.5366"
            y="12.1875"
            width="3.7338"
            height="11.6014"
            transform="rotate(90 17.5366 12.1875)"
            fill="#24728C"
          />
          <rect
            x="17.6031"
            y="12.7876"
            width="2.33362"
            height="11.6324"
            transform="rotate(90 17.6031 12.7876)"
            fill="url(#paint10_linear_375_1366)"
          />
          <rect
            x="5.93503"
            y="12.1875"
            width="3.7338"
            height="1.20015"
            transform="rotate(90 5.93503 12.1875)"
            fill="url(#paint11_linear_375_1366)"
          />
          <rect
            x="4.73511"
            y="12.1875"
            width="3.7338"
            height="0.333375"
            transform="rotate(90 4.73511 12.1875)"
            fill="#195167"
          />
          <path
            opacity="0.2"
            d="M8.4021 13.8261C8.4021 14.1915 8.11532 14.4864 7.76324 14.4864C7.41116 14.4864 7.12439 14.1915 7.12439 13.8261C7.12439 13.4606 7.41116 13.1658 7.76324 13.1658C8.11532 13.1658 8.4021 13.4606 8.4021 13.8261Z"
            fill="#233838"
            stroke="black"
            stroke-width="0.0503465"
          />
          <ellipse
            cx="7.7624"
            cy="13.8263"
            rx="0.46482"
            ry="0.479849"
            fill="#29637B"
          />
          <path
            d="M8.08253 13.8261C8.08253 14.0088 7.93915 14.1562 7.76311 14.1562C7.58707 14.1562 7.44368 14.0088 7.44368 13.8261C7.44368 13.6434 7.58707 13.4959 7.76311 13.4959C7.93915 13.4959 8.08253 13.6434 8.08253 13.8261Z"
            fill="url(#paint12_linear_375_1366)"
            stroke="#1B556F"
            stroke-width="0.0251733"
          />
          <rect
            x="15.794"
            y="3.94821"
            width="0.554275"
            height="1.88777"
            transform="rotate(90 15.794 3.94821)"
            fill="#22627B"
            stroke="#73B3CE"
            stroke-width="0.3125"
          />
          <rect
            x="15.794"
            y="3.94821"
            width="0.554275"
            height="0.820975"
            transform="rotate(90 15.794 3.94821)"
            fill="#22627B"
            stroke="#73B3CE"
            stroke-width="0.3125"
          />
          <rect
            x="15.794"
            y="13.6357"
            width="0.554275"
            height="1.88777"
            transform="rotate(90 15.794 13.6357)"
            fill="#22627B"
            stroke="#73B3CE"
            stroke-width="0.3125"
          />
          <rect
            x="15.794"
            y="13.6357"
            width="0.554275"
            height="0.820975"
            transform="rotate(90 15.794 13.6357)"
            fill="#22627B"
            stroke="#73B3CE"
            stroke-width="0.3125"
          />
          <defs>
            <filter
              id="filter0_i_375_1366"
              x="4.76624"
              y="12.4695"
              width="1.17014"
              height="5.18382"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="1.25" />
              <feGaussianBlur stdDeviation="0.625" />
              <feComposite
                in2="hardAlpha"
                operator="arithmetic"
                k2="-1"
                k3="1"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
              />
              <feBlend
                mode="normal"
                in2="shape"
                result="effect1_innerShadow_375_1366"
              />
            </filter>
            <linearGradient
              id="paint0_linear_375_1366"
              x1="13.7425"
              y1="16.917"
              x2="13.7425"
              y2="18.1838"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#41555D" />
              <stop offset="0.5" stop-color="#132025" />
              <stop offset="1" stop-color="#111C20" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_375_1366"
              x1="5.6169"
              y1="16.9171"
              x2="5.6169"
              y2="18.1839"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#41555D" />
              <stop offset="0.5" stop-color="#132025" />
              <stop offset="1" stop-color="#111C20" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_375_1366"
              x1="18.75"
              y1="9.88565"
              x2="1.875"
              y2="9.88565"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#1F6282" />
              <stop offset="0.54" stop-color="#1E5F7B" />
              <stop offset="1" stop-color="#176386" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_375_1366"
              x1="5.5351"
              y1="5.36661"
              x2="5.5351"
              y2="7.03348"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#23728D" />
              <stop offset="0.5" stop-color="#29718B" />
              <stop offset="1" stop-color="#184D5E" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_375_1366"
              x1="17.6031"
              y1="7.9469"
              x2="19.9367"
              y2="7.9469"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3389B1" />
              <stop offset="0.55" stop-color="#2C7595" />
              <stop offset="0.96" stop-color="#1F4A5D" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_375_1366"
              x1="5.9375"
              y1="3.02083"
              x2="10.9375"
              y2="3.02083"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3389B1" />
              <stop offset="0.55" stop-color="#2C7595" />
              <stop offset="0.96" stop-color="#1F4A5D" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_375_1366"
              x1="7.76311"
              y1="3.79584"
              x2="7.76311"
              y2="4.48134"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#589DB9" />
              <stop offset="1" stop-color="#4A8BA5" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_375_1366"
              x1="17.6032"
              y1="12.6397"
              x2="20.5618"
              y2="12.6397"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.155" stop-color="#063B51" />
              <stop offset="0.375" stop-color="#08415A" />
              <stop offset="0.84" stop-color="#063B51" />
            </linearGradient>
            <linearGradient
              id="paint8_linear_375_1366"
              x1="5.93637"
              y1="8.10523"
              x2="9.87019"
              y2="8.10523"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3389B1" />
              <stop offset="0.55" stop-color="#2C7595" />
              <stop offset="0.96" stop-color="#1F4A5D" />
            </linearGradient>
            <linearGradient
              id="paint9_linear_375_1366"
              x1="6.389"
              y1="12.4695"
              x2="6.389"
              y2="14.1903"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#23728D" />
              <stop offset="0.5" stop-color="#29718B" />
              <stop offset="1" stop-color="#184D5E" />
            </linearGradient>
            <linearGradient
              id="paint10_linear_375_1366"
              x1="17.6031"
              y1="17.6344"
              x2="19.9368"
              y2="17.6344"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3389B1" />
              <stop offset="0.76" stop-color="#2C7595" />
              <stop offset="0.96" stop-color="#1F4A5D" />
            </linearGradient>
            <linearGradient
              id="paint11_linear_375_1366"
              x1="5.93503"
              y1="12.6876"
              x2="9.66883"
              y2="12.6876"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#3389B1" />
              <stop offset="0.55" stop-color="#2C7595" />
              <stop offset="0.96" stop-color="#1F4A5D" />
            </linearGradient>
            <linearGradient
              id="paint12_linear_375_1366"
              x1="7.76311"
              y1="13.4833"
              x2="7.76311"
              y2="14.1688"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#589DB9" />
              <stop offset="1" stop-color="#4A8BA5" />
            </linearGradient>
          </defs>
        </SVGIconRender>
  );
};

export default ServerHardwareControllerNew;
